import React from 'react';
import classNames from 'classnames';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { Button } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';

import css from './SectionHowItWorks.css';
import OptionsWidget from '../../common/OptionsWidget';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';

const SectionHowItWorks = ({ history, isMobile, options, type }) => {
    return (
        <section className={css.root}>
            <div className={css.content}>
                <h2 className={css.subHeading}>
                    <FormattedMessage id="SectionHowItWorks.subHeading" />
                </h2>
                <p className={css.heading}>
                    <FormattedMessage id="SectionHowItWorks.heading" />
                </p>
                <p>
                    <FormattedMessage id={`SectionHowItWorks.description-${type}`} />
                </p>
            </div>

            <OptionsWidget isMobile={isMobile} options={options} />

            <footer className={classNames(css.footer, css.linksHolder)}>
                <Button
                    className={css.subLinkPrimary}
                    type="button"
                    onClick={() =>
                        history.push(
                            createResourceLocatorString(
                                type === 'horse' ? 'SignupRider' : 'SignupHorseowner',
                                routeConfiguration()
                            )
                        )
                    }
                >
                    Kostenlos registrieren
                </Button>
            </footer>
        </section>
    );
};

export default compose(withRouter)(SectionHowItWorks);
